import React from 'react';
import styled from 'styled-components';
import { ReactComponent as Sort } from 'Images/sort.svg';

const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 24px;
  `;

// eslint-disable-next-line import/prefer-default-export
export const SeverityHeader = () => (
  <Icon>
    <Sort />
  </Icon>
);
